import React, {useState, type ComponentProps} from 'react';
import {Slider} from 'components';

interface IInputSliderProps extends ComponentProps<'input'> {
  onSlide: (value: number) => void;
  label: string;
  suffix?: string;
}

const InputSlider = ({onSlide, label, suffix = '', defaultValue, ...props}: IInputSliderProps) => {
  const [value, setValue] = useState(defaultValue);
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between pb-2.5">
        <p className="text-sm">{label}</p>
        <p className="text-sm">
          {value}
          {suffix}
        </p>
      </div>
      <Slider
        {...props}
        value={value}
        onSlide={newValue => {
          setValue(newValue);
          onSlide(newValue);
        }}
      />
    </div>
  );
};

export default React.memo(InputSlider);
